import React from 'react';
import Layout from '../../common/Layout';
import SEO from '../../common/SEO';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import JidelnaVice from './JidelnaVice';

const JidelnaMain = () => {
  return (
    <>
      <SEO title="Jídelna" />
      <Layout>
        <BreadcrumbOne
          title="Jídelna"
          rootUrl="/"
          parentUrl="Domů"
          currentUrl="Jídelna"
        />

        <JidelnaVice />

        <div className="edu-event-details-area edu-event-details bg-color-white">
          <div className="container">
            <div className="row g-5">
              <div className="col-lg-7">
                <div className="content">
                  <h3 className="title">Platby za stravné</h3>
                  <p>
                    Na základě vyhlášky 463/2011 Sb., kterou se mění vyhláška č.
                    107/2005 Sb., o školním stravování, ve znění vyhlášky č.
                    107/2008 Sb. upravujeme ceny stravného takto:
                  </p>
                  <h5>Ceny za stravné platné od 1. 9. 2025:</h5>

                  <h6>CELODENNÍ STRAVOVÁNÍ</h6>

                  <b>Strávníci do 6 let:</b>
                  <ul className="list-item mb--20">
                    <li>
                      Cena celkem <b>47,- Kč</b>
                    </li>
                    <li>Nápoje /pitný režim/ jsou součástí stravování.</li>
                  </ul>

                  <b>Strávníci 7 let:</b>
                  <ul className="list-item mb--20">
                    <li>
                      Cena celkem <b>50,- Kč</b>
                    </li>
                    <li>Nápoje /pitný režim/ jsou součástí stravování.</li>
                  </ul>

                  <b>Strávníci 7-10 let:</b>
                  <ul className="list-item mb--20">
                    <li>
                      Cena celkem <b>33,- Kč</b>
                    </li>
                    <li>Nápoje /pitný režim/ jsou součástí stravování.</li>
                  </ul>

                  <b>Strávníci 11-14 let:</b>
                  <ul className="list-item mb--20">
                    <li>
                      Oběd <b>35,- Kč</b>
                    </li>
                  </ul>

                  <p>
                    Stravné a školné na následující kalendářní měsíc lze platit
                    v hotovosti, bezhotovostně převodem z účtu nebo
                    prostřednictvím inkasa do 20. dne v měsíci - na Vašem účtu
                    je třeba zadat souhlas s inkasní platbou ve prospěch účtu
                    číslo 1284806309/0800. Platba se provede automaticky a bude
                    odpovídat počtu obědů v měsíci (+školné)..
                  </p>
                  <p>
                    <b>
                      Obědy je nutno odhlásit nejpozději jeden den předem do 12
                      hod. Vyzvednutí obědů v případě nemoci je možné v čase od
                      11:00 do 11:30.
                    </b>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default JidelnaMain;
